export type UnsAsset = "" | (string & {});
